import type { FC, SyntheticEvent } from "react";

import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { Txt } from "@jti/ui";

const { sanitize } = dompurify;

type CheckoutLoyaltyPointsBlockProps = {
  title: string;
  text: string;
  isActive?: boolean;
  onClick: ($event: SyntheticEvent) => void;
  disabled?: boolean;
  dataTestid?: string;
};

export const CheckoutLoyaltyPointsBlock: FC<CheckoutLoyaltyPointsBlockProps> = ({
  title,
  text,
  isActive = false,
  onClick,
  disabled = false,
  dataTestid,
}) => {
  const className = classNames("checkout-loyalty-points-block", {
    "checkout-loyalty-points-block--active": isActive,
    "checkout-loyalty-points-block--disabled": disabled,
  });

  return (
    <div className={className} onClick={!disabled ? onClick : () => false} data-testid={`${dataTestid}Button`}>
      <div className={"checkout-loyalty-points-block__title"}>
        <Txt variant={"txt-6"} className={"checkout-loyalty-points-block__title-text"} dataTestId={dataTestid}>
          {title}
        </Txt>
      </div>
      <div className={"checkout-loyalty-points-block__text"}>
        <Txt variant={"txt-2"} className={"checkout-loyalty-points-block__text-field"}>
          <div dangerouslySetInnerHTML={{ __html: sanitize(text) }} />
        </Txt>
      </div>
    </div>
  );
};
